import { defineStore } from "pinia";

type MiscState = {
  isLoading: boolean;
  isLoadingOverride: boolean;
};

export const useMiscStore = defineStore({
  id: "misc",
  state: (): MiscState => {
    return {
      isLoading: false,
      isLoadingOverride: false,
    };
  },
});
